import { environment } from '../../src/environments/environment';

export const API_BASE_URL = environment.url + '/api';
export const AUTH_ENDPOINTS = {
    login: `${API_BASE_URL}/auth/login`,
    logout: `${API_BASE_URL}/auth/logout`,
    confirmEmail: `${API_BASE_URL}/auth/confirm-email`,
    setPassword: `${API_BASE_URL}/auth/set-password`,
    forgotPassword: `${API_BASE_URL}/auth/forgot-password`,
    changePassword: `${API_BASE_URL}/Auth/change-password`,
    refresh: `${API_BASE_URL}/auth/refresh`
}
export const USER_ENDPOINTS = {
  getUsers: `${API_BASE_URL}/user`,
  getUserDetail: (id: number) => `${API_BASE_URL}/user/detail/${id}`,
  postUser: `${API_BASE_URL}/user`,
  putUser: (id: number) => `${API_BASE_URL}/user/${id}`,
  deleteUser: (id: number) => `${API_BASE_URL}/user/${id}`,
  getUserRoles: `${API_BASE_URL}/user/roles`,
  getUserBranchs: `${API_BASE_URL}/user/branchs`,
  getUserClients: `${API_BASE_URL}/user/clients`,
  getUserClient: (id: number) => `${API_BASE_URL}/user/client/${id}`,
  approveOrRejectUser: `${API_BASE_URL}/user/approve-or-reject/`,
  getUserAreas: `${API_BASE_URL}/user/areas`,
  getUsersByArea: (areaId: number) => `${API_BASE_URL}/User/by-area/${areaId}`,
}
export const AREA_ENDPOINTS = {
  createArea: `${API_BASE_URL}/Area/create`,
  updateArea: `${API_BASE_URL}/Area/update`,
  deleteArea: (areaId: number) => `${API_BASE_URL}/Area/delete/${areaId}`,
  getAreasByClient: (clientId: number) => `${API_BASE_URL}/Area/get-by-client/${clientId}`,
  getAreasByUser: (userId: number) => `${API_BASE_URL}/Area/get-by-user/${userId}`,
}
export const CLIENT_ENDPOINTS = {
  getClients: `${API_BASE_URL}/client`,
  getClientDetail: (id: number) => `${API_BASE_URL}/client/detail/${id}`,
  postClient: `${API_BASE_URL}/client`,
  putClient: (id: number) => `${API_BASE_URL}/client/${id}`,
  deleteClient: (id: number) => `${API_BASE_URL}/client/${id}`,
}
export const FORMAL_NOTICE_ENDPOINTS = {
  draft: `${API_BASE_URL}/draft`,
  putDraft: `${API_BASE_URL}/draft`,
  getFormalNoticeDetails: `${API_BASE_URL}/formal-notice/details`,
  getFormalNotice: `${API_BASE_URL}/formal-notice/get-formal-notice`,
  postFormalNotice: `${API_BASE_URL}/formal-notice`,
  putFormalNotice: `${API_BASE_URL}/formal-notice`,
  getFormalNoticeContent: (letterId: number) => `${API_BASE_URL}/formal-notice/content/${letterId}`,
  getFormalNoticeFinalize: (letterId: number) => `${API_BASE_URL}/formal-notice/finalize/${letterId}`,
  deleteFormalNotice: (letterId: number) => `${API_BASE_URL}/formal-notice/${letterId}`,
  postSendFormalNotice: `${API_BASE_URL}/formal-notice/send-notice`,
  getDetailsForBranch: `${API_BASE_URL}/formal-notice/details-by-branch`,
  getFormalNoticeByBranch: `${API_BASE_URL}/formal-notice/get-formal-notice-by-branch`,
  getRemitterAndAgentByCartaId: (letterId: number) => `${API_BASE_URL}/formal-notice/get-remitter-and-agent/${letterId}`,
  auditFormalNotice: `${API_BASE_URL}/formal-notice/AuditFormalNotice`,
  auditUpdateEco: `${API_BASE_URL}/Audit/update-eco`,
  auditUpdateSucursal: `${API_BASE_URL}/Audit/update-sucursal`,

}
export const TEMPLATE_ENDPOINTS = {
  getTemplate: `${API_BASE_URL}/template`,
  getTemplatesByClients: (clientId: number) => `${API_BASE_URL}/template/get-templates-by-clients/${clientId}`,
  getTemplatesByUser: (userId: number) => `${API_BASE_URL}/template/get-templates-by-user/${userId}`,
  postTemplate: `${API_BASE_URL}/template`,
}
export const RECIPIENT_ENDPOINTS = {
  getRecipients: `${API_BASE_URL}/recipient`,
  getRecipient: (id: number) => `${API_BASE_URL}/recipient/${id}`,
  postRecipient: `${API_BASE_URL}/recipient`,
  putRecipient: (id: number) => `${API_BASE_URL}/recipient/${id}`,
  deleteRecipient: (id: number) => `${API_BASE_URL}/recipient/${id}`,
}
export const SENDER = {
  getAreasAndClient: `${API_BASE_URL}/sender`,
  getRemitterById: (id: number) => `${API_BASE_URL}/sender/${id}`,
}

export const PRODUCT = {
  getProducts: `${API_BASE_URL}/product`,
}

export const TRACKING = {
  postTracking: `${API_BASE_URL}/tracking`,
  getTracking: (id: number) => `${API_BASE_URL}/tracking/${id}`,
  postZipCode: `${API_BASE_URL}/tracking/zip-code`
}

export const PROCESS = {
  postProcess: (letterId: number) => `${API_BASE_URL}/process/print/${letterId}`,
  postProcessMassive: `${API_BASE_URL}/process/massive/process-template-massive`,
  postConfirmProcessMassive: `${API_BASE_URL}/process/massive/confirm-template-massive`,
  postSignTemplateMassive: `${API_BASE_URL}/process/massive/sign-template-massive`
}

export const PIN = {
  postPin: `${API_BASE_URL}/pin`,
  putPin: `${API_BASE_URL}/pin`,
  postCheckPin: `${API_BASE_URL}/pin/check`,
  postRecoverPin: `${API_BASE_URL}/pin/recover`,
}


export const ADDOC_ENDPOINTS = {
  getAccuse: `${API_BASE_URL}/Addoc/GetAccuse`,
}
